import React, { useEffect, useState } from 'react';

const COOKIE_KEY = 'dpc_cookie_consent';

const getStoredConsent = () => {
  try {
    const value = localStorage.getItem(COOKIE_KEY);
    return value === 'accepted' ? 'accepted' : value === 'rejected' ? 'rejected' : null;
  } catch {
    return null;
  }
};

const storeConsent = (value) => {
  try {
    localStorage.setItem(COOKIE_KEY, value);
  } catch {
    // Ignore storage errors; essential flows use server sessions + OTP token fallback
  }
};

export const hasCookieConsent = () => getStoredConsent() === 'accepted';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const existing = getStoredConsent();
    if (!existing) {
      setVisible(true);
    }
  }, []);

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-50 animate-dpc-fade-up">
      <div className="mx-auto max-w-5xl mb-4 px-4">
        <div className="bg-ink text-paper rounded-2xl shadow-2xl p-4 sm:p-5 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div className="flex-1">
            <h3 className="text-sm sm:text-base font-semibold mb-1">
              We use cookies to improve your experience
            </h3>
            <p className="text-xs sm:text-sm text-paper/70">
              We use essential cookies to keep your account and checkout secure. With your consent, we also use cookies and local storage for analytics and personalization. You can continue using admin features even if you decline non‑essential cookies.
            </p>
          </div>
          <div className="flex items-center gap-2 sm:gap-3">
            <button
              onClick={() => {
                storeConsent('rejected');
                setVisible(false);
              }}
              className="px-3 py-2 text-xs sm:text-sm font-medium text-paper/80 border border-paper/25 rounded-xl hover:bg-paper/10 transition-colors"
            >
              Essential only
            </button>
            <button
              onClick={() => {
                storeConsent('accepted');
                setVisible(false);
              }}
              className="px-3 sm:px-4 py-2 text-xs sm:text-sm font-semibold rounded-xl bg-accent hover:bg-accent-deep transition-colors shadow-lg"
            >
              Accept all
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;

